var _defs, _title, _path, _path2, _path3, _path4, _rect, _rect2, _rect3;
const _excluded = ["svgRef"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
const SvgGroupAdd = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#lg2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:#fff;}.cls-5{fill:url(#linear-gradient-4);}.cls-6{fill:url(#linear-gradient-5);}.cls-7{fill:none;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.08,
    y1: 5.13,
    x2: 6.63,
    y2: 10.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#327bf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2",
    x1: 14.22,
    y1: 0.5,
    x2: 11.23,
    y2: 16.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 12.04,
    y1: 2.4,
    x2: 4.01,
    y2: 16.15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdb59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f5b53f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 9.93,
    y1: 13.25,
    x2: 15.3,
    y2: 12.21,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006fad"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05007a"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 10.83,
    y1: 10.13,
    x2: 13.73,
    y2: 14.01,
    gradientTransform: "translate(0.05 25.45) rotate(-90)",
    xlinkHref: "#linear-gradient-4"
  }))), _title || (_title = /*#__PURE__*/React.createElement("title", null, "GROUP ADD")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.2,11.5a.2.2,0,0,1-.2-.2v-.16a1.36,1.36,0,0,1,.71-1.2L2,9.11a.63.63,0,0,0,.33-.55V7.94l-.05-.06a2.73,2.73,0,0,1-.68-1.16l0-.06-.05,0a.48.48,0,0,1-.18-.39V5.55a.44.44,0,0,1,.14-.33l.05-.06v-1a1.78,1.78,0,0,1,2-1.59,1.78,1.78,0,0,1,2,1.59v1l0,.06a.51.51,0,0,1,.15.33v.68a.49.49,0,0,1-.19.39l0,0v.06a2.83,2.83,0,0,1-.68,1.16l-.06.06v.62a.63.63,0,0,0,.33.55l1.33.83a1.34,1.34,0,0,1,.71,1.2v.16a.19.19,0,0,1-.19.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M8.78,10.92a.21.21,0,0,1-.21-.21v-.16a1.43,1.43,0,0,1,.74-1.26l1.39-.86a.68.68,0,0,0,.35-.57V7.21L11,7.15a2.92,2.92,0,0,1-.71-1.21l0-.06,0,0a.51.51,0,0,1-.2-.41V4.71a.5.5,0,0,1,.16-.34l.05-.06v-1a1.85,1.85,0,0,1,2.06-1.65,1.87,1.87,0,0,1,2.07,1.65v1l.05.06a.54.54,0,0,1,.16.34v.71a.54.54,0,0,1-.2.41l0,0,0,.06a2.92,2.92,0,0,1-.71,1.21l-.06.06v.65a.68.68,0,0,0,.35.57l1.38.86A1.42,1.42,0,0,1,16,10.55v.16a.21.21,0,0,1-.21.21Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M3.31,12.86A.29.29,0,0,1,3,12.58v-.22a1.93,1.93,0,0,1,1-1.68L5.88,9.53a.89.89,0,0,0,.46-.77V7.9l-.07-.08A3.87,3.87,0,0,1,5.32,6.2l0-.08-.08-.06A.73.73,0,0,1,5,5.51v-1a.65.65,0,0,1,.2-.46L5.24,4V2.65A2.49,2.49,0,0,1,8,.44a2.48,2.48,0,0,1,2.76,2.21V4l.07.08a.67.67,0,0,1,.2.46v1a.73.73,0,0,1-.25.55l-.07.06,0,.08a3.87,3.87,0,0,1-.95,1.62l-.07.08v.86a.89.89,0,0,0,.46.77L12,10.68a1.93,1.93,0,0,1,1,1.68v.22a.29.29,0,0,1-.28.28Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M16,12.75A3.25,3.25,0,1,1,12.75,9.5,3.26,3.26,0,0,1,16,12.75Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 10.51,
    y: 12.14,
    width: 4.48,
    height: 1.12,
    rx: 0.56
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 10.51,
    y: 12.14,
    width: 4.48,
    height: 1.12,
    rx: 0.56,
    transform: "translate(25.45 -0.05) rotate(90)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    width: 16,
    height: 16
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGroupAdd, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/GroupAdd.67edea73.svg";
export { ForwardRef as ReactComponent };